// extracted by mini-css-extract-plugin
module.exports = {"section":"_1w9AYxetFqVLSzCnyvolZP","image":"_3LgHt6k1xu_oA3JwUp3hXw","twocol":"_2sY3M6ZgcCtdvWgLLvyh4k"};